import React, { useRef, useCallback, useState } from 'react';
import { Form } from '@unform/web';
import { FormHandles } from '@unform/core';
import { IoMdSearch } from 'react-icons/io';

import InputWithoutTitle from '../../../../components/InputWithoutTitle';
import {
  GetSheetPatientsByFilter as ListFilter,
  GetSheetPatientsByFilterResponse as ListData,
} from '../../../../services/sheet';

import { Container, Title, GridContent, Field, Button } from './styles';
import ButtonFilterRangeDate, {
  DateValueProps,
} from '../../../../components/ButtonFilterRangeDate';

interface FilterProps {
  totalSheetPatients: number;
  setListFilter(listFilter: React.SetStateAction<ListFilter>): void;
  listData: ListData;
  onChangePage: (page: number) => void;
}

const Filter: React.FC<FilterProps> = ({
  totalSheetPatients,
  setListFilter,
  listData,
  onChangePage,
}) => {
  const formRef = useRef<FormHandles>(null);

  const [datesSelected, setDatesSelected] = useState<Partial<DateValueProps>>(
    {},
  );

  const handleSubmit = useCallback(() => {
    onChangePage(1);

    setListFilter((prevState) => ({
      ...prevState,
      ...formRef.current?.getData(),
      startDate: datesSelected.startDate,
      endDate: datesSelected.endDate,
    }));
  }, [datesSelected, onChangePage, setListFilter]);

  const handleUpdateDate = useCallback(
    ({ startDate, endDate }: DateValueProps) => {
      if (startDate && endDate) {
        setDatesSelected({
          startDate: new Date(startDate),
          endDate: new Date(endDate),
        });
      }

      if (!startDate && !endDate) {
        setDatesSelected({});
      }
    },
    [],
  );

  return (
    <Container>
      <h1>Filtrar resultado</h1>
      <Title>
        <h2>{listData.sheetName}</h2>
        {totalSheetPatients === 0 && <span>Nenhuma pendência</span>}
        {totalSheetPatients === 1 && (
          <span>{totalSheetPatients} pendência</span>
        )}
        {totalSheetPatients > 1 && <span>{totalSheetPatients} pendências</span>}
      </Title>
      <Form ref={formRef} onSubmit={handleSubmit}>
        <GridContent>
          <Field gridArea="pn">
            <label>Nome do paciente</label>
            <InputWithoutTitle name="patientName" />
          </Field>
          <Field gridArea="dt">
            <label>Período de atribuição</label>
            <ButtonFilterRangeDate
              dateValue={datesSelected}
              onChange={handleUpdateDate}
              canClearDates
            />
          </Field>
          <Field gridArea="bt" isButton>
            <Button type="submit">
              <IoMdSearch />
              Buscar
            </Button>
          </Field>
        </GridContent>
      </Form>
    </Container>
  );
};

export default Filter;
